import React from 'react';
import TextWidget from '../TextWidget/TextWidget.js'
import moment from 'moment-timezone'

class TimeZoneWidget extends React.Component {

  constructor() {
    super();
    this.state = {
      time: "00:00"
    };
  }

  refresh() {
    this.setState({time: moment().tz(this.props.timeZone).format('h:mm a')});
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      time:moment().tz(this.props.timeZone).format('h:mm a')
    })
  }

  render() {
    return (
      <TextWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} refreshInterval={1} title={this.props.city} value={this.state.time} />
    )
  }
}

export default TimeZoneWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/TimeZoneWidget/TimeZoneWidget.js